import { styled } from 'styled-components';
import { InfoIcon, CloseIcon } from '@icons';

export const TooltipContainer = styled.div`
  position: relative;
  display: inline-block;
`;

export const TooltipTrigger = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.7;
  }
`;

export const TooltipIcon = styled(InfoIcon)`
  width: 16px;
  height: 16px;
  color: ${({ theme }) => theme.colors.primary600};
`;

export const TooltipContent = styled.div`
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 0.5rem;
  background-color: ${({ theme }) => theme.colors.primary600};
  color: white;
  padding: 1rem;
  font-size: 10px;
  border-radius: 8px;
  min-width: 300px;
  max-width: 400px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  animation: fadeIn 0.2s ease-in;

  &::after {
    content: '';
    position: absolute;
    bottom: -8px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid ${({ theme }) => theme.colors.primary600};
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateX(-50%) translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateX(-50%) translateY(0);
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    min-width: 250px;
    max-width: 100%;
    right: auto;
    left: 50%;

    &::after {
      left: 50%;
      right: auto;
      transform: translateX(-50%);
    }
  }
`;

export const TooltipHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
`;

export const TooltipTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  margin: 0;
  color: white;
`;

export const TooltipCloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.7;
  }
`;

export const TooltipCloseIcon = styled(CloseIcon)`
  width: 18px;
  height: 18px;
  color: white;
`;

export const TooltipBody = styled.p`
  font-size: 0.875rem;
  line-height: 1.5;
  margin: 0;
  color: white;
  font-weight: 400;
`;
